"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.top = exports.right = exports.left = exports.bottom = exports.all = void 0;
require("./margin.css");
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */

const all = {
  0: "cds-0-_kma6p3",
  1: "cds-1-_9ut6s4",
  2: "cds-2-_9m6zem",
  3: "cds-3-_jpl872",
  4: "cds-4-_9x4m5u",
  5: "cds-5-_14f2zp1",
  6: "cds-6-_7ipf1b",
  7: "cds-7-_14gy4co",
  8: "cds-8-_1utzrm6",
  9: "cds-9-_1ld9ukn",
  10: "cds-10-_6lsyo1",
  0.5: "cds-0_5-_y3e6ro",
  1.5: "cds-1_5-_dgdhsn"
};
exports.all = all;
const top = {
  0: "cds-0-_no4wln",
  1: "cds-1-_csdm1d",
  2: "cds-2-_ru3b5s",
  3: "cds-3-_1tsa1mn",
  4: "cds-4-_2d3lha",
  5: "cds-5-_9aff6y",
  6: "cds-6-_4ggp5x",
  7: "cds-7-_1m4z1t8",
  8: "cds-8-_1hjad0h",
  9: "cds-9-_3zcb3x",
  10: "cds-10-_kmjpoa",
  0.5: "cds-0_5-_859rom",
  1.5: "cds-1_5-_16y5jao"
};
exports.top = top;
const bottom = {
  0: "cds-0-_1yh2lxt",
  1: "cds-1-_l41vbt",
  2: "cds-2-_2xdpnr",
  3: "cds-3-_1u7yh01",
  4: "cds-4-_1bokd63",
  5: "cds-5-_1ao8k3x",
  6: "cds-6-_zvcqp3",
  7: "cds-7-_1nqubva",
  8: "cds-8-_g5v9tn",
  9: "cds-9-_1qwd2hv",
  10: "cds-10-_28wl5",
  0.5: "cds-0_5-_1nwzoqb",
  1.5: "cds-1_5-_1hb21d3"
};
exports.bottom = bottom;
const left = {
  0: "cds-0-_1ikkgje",
  1: "cds-1-_1yp1yx6",
  2: "cds-2-_jlx4gi",
  3: "cds-3-_w36kip",
  4: "cds-4-_rhp3r0",
  5: "cds-5-_3h0hh7",
  6: "cds-6-_xc26ul",
  7: "cds-7-_remqv5",
  8: "cds-8-_7v3skb",
  9: "cds-9-_16mwbyl",
  10: "cds-10-_zffjiy",
  0.5: "cds-0_5-_r6uilt",
  1.5: "cds-1_5-_1jwa6lb"
};
exports.left = left;
const right = {
  0: "cds-0-_58x1ji",
  1: "cds-1-_8uqdc",
  2: "cds-2-_oahqgk",
  3: "cds-3-_3hlyk3",
  4: "cds-4-_1392ee",
  5: "cds-5-_1951drs",
  6: "cds-6-_fmhloy",
  7: "cds-7-_2gylru",
  8: "cds-8-_1vhaamj",
  9: "cds-9-_179q15c",
  10: "cds-10-_139w8tg",
  0.5: "cds-0_5-_17snmy2",
  1.5: "cds-1_5-_128bcf3"
};
exports.right = right;